/**
 * Button Component
 *
 * A reusable button component that follows the StartupHive design system.
 *
 * Props:
 * - children: Button content (required)
 * - variant: 'primary' | 'secondary' | 'ghost' (default: 'primary')
 * - size: 'sm' | 'md' | 'lg' (default: 'md')
 * - disabled: boolean (default: false)
 * - onClick: function
 * - type: 'button' | 'submit' | 'reset' (default: 'button')
 * - className: additional CSS classes
 * - ...rest: any other button attributes
 */

function Button({
  children,
  variant = 'primary',
  size = 'md',
  disabled = false,
  onClick,
  type = 'button',
  className = '',
  ...rest
}) {
  const variantClass = `btn-${variant}`
  const sizeClass = `btn-${size}`
  const classes = `btn ${variantClass} ${sizeClass} ${className}`.trim()

  return (
    <button
      type={type}
      className={classes}
      disabled={disabled}
      onClick={onClick}
      {...rest}
    >
      {children}
    </button>
  )
}

export default Button
